import { render, staticRenderFns } from "./PMPhotoCarousel.vue?vue&type=template&id=75bcc97f&"
import script from "./PMPhotoCarousel.vue?vue&type=script&lang=ts&"
export * from "./PMPhotoCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./PMPhotoCarousel.vue?vue&type=style&index=0&id=75bcc97f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports